package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_12_08_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in the Gleaming Horde inn at breakfast after a good night’s sleep.  Goram is still processing the revelations from Falorn the night before. Why did Falorn desert his brothers in The Fist? What kind of person does that? Will he betray us? Falorn explains that the other members of his crew were breaking the code of The Fist, and he felt that he couldn’t remain.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday and Caper visit parks in the city to touch grass and fly among the trees.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram and Annette follow Falorn while he walks around town undisguised in order to detect the presence of any more spies. Goram and Annette do not detect anyone following him, and all 3 return to the Gleaming Horde.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram returns to the Traveler’s Doorstep to pick up his bow, and afterwards he meets with Voth Gardul (with whom he may have a lost family connection). Afterward Goram returns to the Gleaming Horde.")
    }
}
